export const Home = {
  Dialog: {
    Title: 'ご予約が完了しました',
    ReviseTitle: 'ご予約を修正しました',
    DispensingReadyCallingTitle: 'お薬できあがり呼出登録が完了しました。',
    Message: '薬剤師が処方箋を確認しています。<br>予約管理をご確認ください。',
    DispensingReadyCallingMessage:
      '薬剤師が調剤を行っています。<br>お知らせ通知をご確認ください。',
    ReservedUseMynaGuidance:
      '在宅受付Webを表示の<br>ブラウザ画面は閉じてください。',
    AccountCreationGuidance:
      'アカウントを作成していただくと<br>次回の予約が簡単になり<br>お薬の自動登録、オンライン服薬指導、配送受取りなどの機能が<br>ご利用いただけます。',
    MainButtonName: 'OK',
    AccountCreationGuidanceMainButtonName: 'アカウント作成',
    AccountCreationGuidanceSubButtonName: 'アカウント作成せずに閉じる',
    ServiceMergerAndMigration: {
      Title: 'サービス統合とデータ移行のお願い',
      Acknowledgement: 'いつも本アプリをご利用いただき、ありがとうございます。この度、本アプリはより良いサービス提供のため、2026年6月30日をもちまして、LINEアプリへサービスを統合することとなりました。つきましては、大変お手数ではございますが、下記リンクの案内に沿って、期限までにデータの引き継ぎ・保存をお願いいたします。',
      DirectionIs: '詳細の移行手順は',
      Here: 'こちら',
      Close: '閉じる',
    },
  },
  UserInfo: {
    CustomerNumberLabel: 'お客様番号 ',
    NotLoggedInText: 'ログインしていません',
  },
  DateTime: {
    Year: '年',
    Month: '月',
    Date: '日',
    DayOfWeek: '({dayOfWeek})',
  },
  Tab: {
    Corporation: '健康サポート',
    InvestigatingSymptoms: '症状を調べる',
    Dispensing: '薬をもらう',
    TakingMedicine: '薬を飲む',
    VitalData: '健康管理',
    HealthCheck: '健診データ',
  },
  Closing: {
    Heading: '「タヨリス」アプリ終了のお知らせ',
    Introduction: 'タヨリスアプリの提供は、2026年6月30日をもちまして終了いたしました。これまでのご愛顧に心より御礼申し上げます。今後は、LINEミニアプリのご利用をお願いいたします。',
    ContinueWithLine: 'LINEでサービスを利用する',
    LineId: 'ID検索: @372ngufl',
    AppContact: {
      Heading1: '【本アプリに関するお問い合わせ】',
      Heading2: 'タヨリスコールセンター',
      Phone: '電話番号: 03-6869-8831',
      OpeningHours: '受付時間: 平日 9:00-18:00（土日祝を除く）',
    },
    LineMiniAppContact: {
      Heading1: '【LINEミニアプリに関するお問い合わせ】',
      Heading2: 'お問い合わせフォーム',
      OpeningHours: '受付時間: 平日 10:00-18:00',
      Steps: [
        '本画面「LINEでサービスを利用する」をタップ',
        'トーク画面＞メニューより「お薬手帳アプリ」をタップ',
        '設定＞お問い合わせからご連絡ください。',
      ],
    }
  },
};
